import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import zeeqrbanner from '../../../assets/casestudy/zeeqrbanner.webp';
import ZEEQRCaseStudy from '../../../assets/casestudy/ZEEQRCaseStudy.webp';
import zeeqr2ndimg from '../../../assets/casestudy/zeeqr2ndimg.webp';
import zeeqr3rdimg from '../../../assets/casestudy/zeeqr3rdimg.png';
import Mongodbicon from '../../../assets/img/mongodbicon.svg';
import Nodeicon from '../../../assets/img/nodeicon.svg';
import Reacticon from '../../../assets/img/reacticon.svg';
import Expressicon from '../../../assets/img/expressicon.svg';
import Ajtech2ndimg from '../../../assets/casestudy/ajtech2ndimg.webp';
import amberarom1stimg from '../../../assets/casestudy/amberarom1stimg.webp';
const Zeeqr = () => {
    const caseStudiesB = [
   {
    image: Ajtech2ndimg,
    title: 'AJTechIndustry',
    category: 'Website Design',
     pagelink:'/ajtechIndustry',
    link: 'https://agtechindustries.com/',
  },
   {
    image: amberarom1stimg,
    title: 'Amber Aroma',
    category: 'Website Design',
     pagelink:'/amber-aroma',
    link: 'https://amberarom.com/',
  },
];
  const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];
  return (
    <CaseStudys
      title="ZEEQR"
      caseStudies={caseStudiesB} 
      subtitle="Smart & Sustainable Digital Networking"
      header='Smart & Sustainable Digital Networking'
      websiteUrl='https://zeeqr.com/'
     
      industry="Digital Networking & Smart Business Solutions"
      services={servicesB}
      description={
        <>
          <span>ZEEQR </span> ZEEQR is a forward-thinking platform offering NFC-enabled digital business cards that simplify professional networking through tap-and-share technology. To support its growth and clearly communicate its value, a dedicated website was designed and developed. The site showcases ZEEQR’s features, guides users through the benefits of digital cards, and provides a smooth entry point for customers to explore and engage with the brand. The project focused on creating a modern, informative, and easy-to-navigate web experience aligned with ZEEQR’s innovative identity.
        </>
      }
      objective={{
        heading: 'Building a Platform to Simplify Digital Connectivity with QR and NFC',
        content: (
          <>
            <p className={styles.projectText}>
       The objective of the ZEEQR website project was to create a user-friendly digital platform that effectively communicates the benefits of NFC-enabled business cards and simplifies the process of connecting professionals. The goal was to design a visually appealing and intuitive website that highlights the innovative features of ZEEQR’s service, encourages user engagement, and provides a seamless experience for visitors to learn about, purchase, and use digital business cards. The project aimed to enhance brand visibility, streamline customer interactions, and support ZEEQR's mission to modernize networking.
            </p>

           
          </>
        ),
      }}
      process={{
        heading: "Bringing Zeeqr’s Digital Connectivity Tools to Life Online",
        content: (
          <>
            <p className={styles.projectText}>
      The ZEEQR website project began with a thorough understanding of the brand’s vision, target audience, and the features of their NFC-enabled digital business cards. The design phase focused on creating a modern, professional, and intuitive interface that clearly communicated the benefits of the product. After finalizing the wireframes and visual design, development was carried out with a focus on responsive design and seamless user experience. Key features like easy navigation, detailed product information, and a simple call-to-action for users were prioritized. Throughout the process, regular feedback from stakeholders ensured the site aligned with ZEEQR's goals. After extensive testing for performance and usability, the website was launched, providing an engaging and informative platform for customers.
            </p>

         

           
          </>
        ),
      }}
      impact={{
        heading: 'Making QR and NFC Solutions Easy to Discover and Use',
        content: (
          <>
            <p className={styles.projectText}>
     The ZEEQR website has significantly enhanced the brand’s online presence and streamlined its customer engagement. The user-friendly design allows potential clients to easily explore the benefits of NFC-enabled digital business cards and understand how they can simplify networking. The website's clear call-to-action and seamless navigation have increased user sign-ups and conversions. By showcasing ZEEQR's innovative technology, the site has helped position the brand as a modern solution for professional networking, driving greater awareness and adoption of their service.
            </p>
           
           
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
In conclusion, the ZEEQR website successfully delivered an engaging and informative platform that reflects the brand’s innovative approach to professional networking. By focusing on user experience and seamless functionality, the website has made it easier for professionals to discover, understand, and adopt NFC-enabled digital business cards. The project not only boosted the brand’s online presence but also supported ZEEQR’s mission to simplify and modernize networking practices.
            </p>
           
          </>
        ),
      }}
      heroImage={zeeqrbanner} // Add the hero image
      projectImage={ZEEQRCaseStudy}
       projectImage2={zeeqr2ndimg}
           projectImage3={zeeqr3rdimg}
       // Add the project image
      technologies={[
           { name: 'MongoDB', icon: Mongodbicon },
        { name: 'Node.js', icon: Nodeicon },
        { name: 'React', icon: Reacticon },
        { name: 'Express.js', icon: Expressicon },
      ]} // Add the technologies used
      timescale="2 Weeks" // Add the timescale
      launchDate="February 2025" // Add the launch date
    />
  );
};

export default Zeeqr;